import AudioSvg from '@assets/audio';
import VideoSvg from '@assets/video';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { I18N_PROFILE_CONTEXT } from '../ProfileForm.constants';
import { TabButtonContainer, TabButtonIcon, TabButtonText } from './TabButton.styles';
import { TabButtonProps } from './TabButton.types';

export const TabButton = ({ type, active, onClick }: TabButtonProps): JSX.Element => {
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  return (
    <TabButtonContainer isActive={active} onClick={onClick}>
      <TabButtonIcon isActive={active}>
        {type === 'audio' ? <AudioSvg width={16} height={16} /> : <VideoSvg width={16} height={16} />}
      </TabButtonIcon>
      <TabButtonText isActive={active}>{t(type)}</TabButtonText>
    </TabButtonContainer>
  );
};
